<template>
  <div v-if="summary" class="summary-container">
    <div v-if="summary.selectedTeacher" class="card-body">
      <div class="white-chip">
        <span>
          <b>Tipo de Maestro:</b>
          {{ summary.selectedTeacher.name }}
        </span>
      </div>
    </div>
    <div class="card-body">
      <div v-if="summary.needsSubareas" class="gray-chip">
        <b>Sub Áreas</b>
      </div>
      <div
        v-if="validator.hasSubAreaSectionError(programServiceAreaId)"
        class="error-container"
      >
        <Error variant="no-border">
          <template #action-text>
            <p>
              <em class="fa fa-times-circle" />
              Debe seleccionar una Sub Área, para completar la misma favor <span class="program-service-tab__redirect" @click="programServiceTabRedirect(TabAliasEnum.SubAreas)">oprima aquí.</span>
            </p>
          </template>
        </Error>
      </div>
      <div
        v-if="
          summary.needsSubareas &&
            summary.selectedSubAreas &&
            summary.selectedSubAreas.length > 0
        "
        class="row"
      >
        <div
          v-for="subarea in summary.selectedSubAreas"
          :key="subarea.id"
          class="white-chip"
        >
          <span>{{ subarea.name }}</span>
        </div>
      </div>
    </div>
    <hr
      v-if="summary.selectedSubAreas && summary.selectedSubAreas.length > 0"
      class="separator"
    />
    <div class="row columns-container card-body">
      <div class="col-4">
        <div class="gray-chip">
          <b>Fortalezas</b>
        </div>
        <div
          v-if="validator.hasStrengthSectionError(programServiceAreaId)"
          class="error-container"
        >
          <Error variant="no-border">
            <template #action-text>
              <p>
                <em class="fa fa-times-circle" />
                Debe seleccionar una Fortaleza, para completar la misma favor <span class="program-service-tab__redirect" @click="programServiceTabRedirect(TabAliasEnum.Strengths)">oprima aquí.</span>
              </p>
            </template>
          </Error>
        </div>
        <div
          v-if="validator.hasLevelSectionError(programServiceAreaId)"
          class="error-container"
        >
          <Error variant="no-border">
            <template #action-text>
              <p>
                <em class="fa fa-times-circle" />
                Debe documentar el nivel (L) de cada destreza seleccionada, para completar la misma favor <span class="program-service-tab__redirect" @click="programServiceTabRedirect(TabAliasEnum.Strengths)">oprima aquí.</span>
              </p>
            </template>
          </Error>
        </div>
        <div
          v-if="
            summary.selectedStrengths && summary.selectedStrengths.length > 0
          "
          class="column-content"
        >
          <p v-for="strength in summary.selectedStrengths" :key="strength.id">
            {{ strength.name }}
            <span v-if="strength.value">({{ strength.value }})</span>
          </p>
        </div>
      </div>
      <div class="col-4">
        <div class="gray-chip">
          <b>Necesidades</b>
        </div>
        <div
          v-if="validator.hasNecessitySectionError(programServiceAreaId)"
          class="error-container"
        >
          <Error variant="no-border">
            <template #action-text>
              <p>
                <em class="fa fa-times-circle" />
                Debe seleccionar una Necesidad, para completar la misma favor <span class="program-service-tab__redirect" @click="programServiceTabRedirect(TabAliasEnum.Needs)">oprima aquí.</span>
              </p>
            </template>
          </Error>
        </div>
        <div
          v-if="validator.hasLevelSectionError(programServiceAreaId)"
          class="error-container"
        >
          <Error variant="no-border">
            <template #action-text>
              <p>
                <em class="fa fa-times-circle" />
                Debe documentar el nivel (L) de cada destreza seleccionada, para completar la misma favor <span class="program-service-tab__redirect" @click="programServiceTabRedirect(TabAliasEnum.Needs)">oprima aquí.</span>
              </p>
            </template>
          </Error>
        </div>
        <div
          v-if="
            summary.selectedNecessities &&
              summary.selectedNecessities.length > 0
          "
          class="column-content"
        >
          <p
            v-for="necessity in summary.selectedNecessities"
            :key="necessity.id"
          >
            {{ necessity.name }}
            <span v-if="necessity.value">({{ necessity.value }})</span>
          </p>
        </div>
      </div>
      <div class="col-4">
        <div class="gray-chip">
          <b>Procedimientos</b>
        </div>
        <div
          v-if="validator.hasProcedureSectionError(programServiceAreaId)"
          class="error-container"
        >
          <Error variant="no-border">
            <template #action-text>
              <p>
                <em class="fa fa-times-circle" />
                Debe seleccionar un Procedimiento, para completar el mismo favor <span class="program-service-tab__redirect" @click="programServiceTabRedirect(TabAliasEnum.Procedures)">oprima aquí.</span>
              </p>
            </template>
          </Error>
        </div>
        <div
          v-if="
            summary.selectedProcedures && summary.selectedProcedures.length > 0
          "
          class="column-content"
        >
          <p
            v-for="procedure in summary.selectedProcedures"
            :key="procedure.id"
          >
            {{ procedure.name }}
          </p>
        </div>
      </div>
    </div>
    <div class="row columns-container card-body">
      <div class="col-12">
        <div class="gray-chip">
          <b>{{ summary.showObjetivesSection ? 'Meta(s) y Objetivo (s)': 'Meta(s)'}}</b>
        </div>
      </div>
      <div class="col-12">
        <div class="error-container custom-margin-bottom">
          <Error
            v-if="validator.hasGoalsError(programServiceAreaId)"
            variant="no-border"
          >
            <template #action-text>
              <p>
                <em class="fa fa-times-circle" />
                <span v-if="validator.minGoalsRequired(programServiceAreaId) == 1">Debe crear una <b>Meta</b>, para completar la misma favor <span class="program-service-tab__redirect" @click="programServiceTabRedirect(TabAliasEnum.Goals)">oprima aquí.</span></span>
                <span v-else>Debe contar con un mínimo de {{ validator.minGoalsRequired(programServiceAreaId) }} Metas, para completar la misma favor <span class="program-service-tab__redirect" @click="programServiceTabRedirect(TabAliasEnum.Goals)">oprima aquí.</span></span>
              </p>
            </template>
          </Error>

          <Error
            v-if="validator.hasSubAreaWithoutGoal(programServiceAreaId)"
            variant="no-border"
          >
            <template #action-text>
              <p>
                <em class="fa fa-times-circle" />
                Debe relacionar todas las sub áreas a las metas, para completar la misma favor <span class="program-service-tab__redirect" @click="programServiceTabRedirect(TabAliasEnum.Goals)">oprima aquí.</span>
              </p>
            </template>
          </Error>

          <Error
            v-if="validator.hasIncompleteNecessitySelection(programServiceAreaId)"
            variant="no-border"
          >
            <template #action-text>
              <p>
                <em class="fa fa-times-circle" />
                Debe relacionar todas las necesidades a las metas, para completar la misma favor <span class="program-service-tab__redirect" @click="programServiceTabRedirect(TabAliasEnum.Goals)">oprima aquí.</span>
              </p>
            </template>
          </Error>
        </div>
      </div>

      <div
        v-if="
          summary.selectedGoalsWithObjectives &&
          summary.selectedGoalsWithObjectives.length > 0
        "
        class="column-content col-12 pl-3"
      >
        <div
          v-for="(goal, goalIdx) in summary.selectedGoalsWithObjectives"
          :key="goalIdx"
          class="row"
        >
          <hr v-if="goalIdx != 0" class="separator w-100 mb-24" />
          <div v-if="summary.needsSubareas" class="col-12">
            <p class="mb-24">
              <b>Sub-Área:</b>
              {{ goal.subAreaDesc }}
            </p>
          </div>
          <div class="col-12">
            <p class="mb-24">
              <b>Meta # {{ goalIdx + 1 }}:</b>
              {{ goal.spaLongDescription }}
            </p>
          </div>
          
          <div class="mb-24 col-12">
            <div class="row">
              <div class="col-12">
                <p><b>Fortalezas/Necesidades</b></p>
              </div>
              <div
                v-if="validator.hasGoalWithoutNecessity(programServiceAreaId) && goal.strenghtsAndNecessities.length == 0"
                class="error-container"
              >
                <Error variant="no-border">
                  <template #action-text>
                    <p>
                      <em class="fa fa-times-circle" />
                      Debe relacionar las necesidades a la meta, para completar la misma favor <span class="program-service-tab__redirect" @click="programServiceTabRedirect(TabAliasEnum.Goals)">oprima aquí.</span>
                    </p>
                  </template>
                </Error>
              </div>
              <div class="col-12">
                <ol>
                  <li v-for="skill in goal.strenghtsAndNecessities">{{ skill.name }} <b>{{ `[${skill.isStrength ? 'Fortaleza' : 'Necesidad'}]` }}</b></li>
                </ol>
              </div>
              <div v-if="summary.showObjetivesSection">
                <div class="col-12">
                  <p><b>Objetivos:</b></p>
                </div>
                <div class="col-12">
                  <div
                    v-if="
                      goal.peiProgramServiceObjective &&
                        goal.peiProgramServiceObjective.length == 0 &&
                        validator.isTriggered
                    "
                    class="error-container"
                  >
                    <Error variant="no-border">
                      <template #action-text>
                        <p>
                          <em class="fa fa-times-circle" />
                          Debe crear un <b>Objetivo</b>, para completar el mismo favor <span class="program-service-tab__redirect" @click="programServiceTabRedirect(TabAliasEnum.Goals)">oprima aquí.</span>
                        </p>
                      </template>
                    </Error>
                  </div>
                </div>
                <div
                  v-if="
                    goal.peiProgramServiceObjective &&
                      goal.peiProgramServiceObjective.length > 0
                  "
                  class="col-12"
                >
                  <div class="row">
                    <div
                      v-for="(objective,
                      objectiveIdx) in goal.peiProgramServiceObjective"
                      :key="objectiveIdx"
                      class="col-12"
                    >
                      <p>
                        <b>{{ goalIdx + 1 }}.{{ objectiveIdx + 1 }}</b>
                        {{ objective.objectiveDescription }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="gray-chip">
          <b>Resumen de Resultados</b>
        </div>
        <div
          v-if="validator.hasResultSummarySectionError(programServiceAreaId)"
          class="error-container"
        >
          <Error
            message="Debe documentar si está de acuerdo con el resumen de resultados."
            variant="no-border"
          />
        </div>
        <div
          v-if="hasErrorInResultSummary"
          class="error-container"
        >
          <Error
            message="Debe documentar el Resumen de Resultados."
            variant="no-border"
          />
        </div>
      </div>
      <div class="col-4">
        <div class="gray-chip">
          <b>Servicios Compensatorios</b>
        </div>
        <div v-if="hasCompensationServiceInvalid" class="error-container">
          <Error
            message="Debe documentar el plan de compensación de servicios."
            variant="no-border"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Error from "@/components/common/Error";
import store from "@/store/index";
import TabAliasEnum from "@/components/pei/programservice/enum/TabAliasEnum";

export default {
  name: "ProgramServiceSummary",
  components: {
    Error
  },
  data() {
    return {
      summary: null,
      resources: [],
      TabAliasEnum: TabAliasEnum,
    };
  },
  props: {
    programServiceAreaId: {
      type: Number,
      required: true
    },
    validateCompensation: {
      type: Boolean,
      required: false
    },
    hasErrorInResultSummary: {
      type: Boolean,
      required: false
    },
    ReadOnly: {
      type: Boolean,
      default: false
    },
    academicYearId: {
      type: Number,
    },
  },
  methods: {
    programServiceTabRedirect(tabAlias) {
      const path = `/pei/addprogramservice?programservicearea=${this.programServiceAreaId}&tab=${tabAlias}`;
      this.$router.push({ path: path });
    },
    async getProgramServiceSummary() {
      if (this.programServiceAreaId == 0) {
        return;
      }

      try {
        const { data } = await this.$ApiGet(`api/pei/getprogramserviceareasummary/${this.programServiceAreaId}`);
        this.summary = data;
      } catch(err) {
        console.error(err);
      }
    },
  },
  computed: {
    validator() {
      return store.getters.tab4Validator;
    },
    hasCompensationServiceInvalid() {
      return this.validateCompensation || this.validator.hasCompensationServiceInvalid(this.programServiceAreaId);
    }
  },
  async mounted() {
    await this.getProgramServiceSummary();
  }
};
</script>
<style scoped>
.summary-container {
  width: calc(100vw - 300px);
}
.summary-container p {
  margin: 0;
  word-wrap: break-word;
}

.card-body {
  padding-bottom: 0;
}
.mb-48.container {
  margin-left: 0;
  padding-left: 0;
}
.separator {
  border-bottom: 1px solid #e2e2e2;
  border-top: 0;
  margin: 0;
}
.columns-container .col-12,
.columns-container .col-4 {
  padding: 0;
}
.columns-container {
  margin-bottom: 24px;
}
.column-content {
  padding: 0 15px;
}
.white-chip {
  border: 1px solid #b5c3bc;
  border-radius: 15px;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 24px;
  margin-right: 24px;
  padding: 0 15px;
  width: fit-content;
}
.gray-chip {
  background-color: #b5c3bc;
  border: 1px solid #b5c3bc;
  border-radius: 15px;
  color: white;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 24px;
  margin-right: 24px;
  padding: 0 15px;
  width: fit-content;
}
.mb-24,
.summary-container p.mb-24 {
  margin-bottom: 24px;
}
.mb-48 {
  margin-bottom: 48px;
}
.error-container {
  width: fit-content;
}

.custom-margin-bottom {
  margin-bottom: 20px;
}

.program-service-tab__redirect {
  cursor: pointer;
  text-decoration: underline;
}
</style>
